<script setup>
  import { ref } from "vue";

  const props = defineProps({
    color: { type: Object, required: true }
  });

  // Definir o evento que será enviado para o pai
  const emit = defineEmits(['select']);

  const imageLoaded = ref(false);
  const handleImageLoad = () => { imageLoaded.value = true; };
</script>

<template>
  <div class="card" @click="emit('select', color)" style="cursor: pointer;">
    <div class="card-content-color"
         v-balloontip="{
        content: `${String(color.value).padStart(2, '0')} - ${color.name}`,
        html: true,
        placement: 'top'
      }">
      <img
        :alt="color.name"
        :src="color.featured_image" :class="{ 'loaded': imageLoaded }" @load="handleImageLoad">
    </div>
    <div class="content-text">
      <h2 class="title-card">{{String(color.value).padStart(2, '0')}} - {{ color.name }}</h2>
    </div>
  </div>
</template>


<style scoped>

  .card-content-color img {
    transition: transform 0.3s ease-in-out, opacity 0.5s ease-in;
    width: 100%;
    height: auto;
    display: block;
    border-radius: 10px;
    opacity: 0.5;
  }

  .card-content-color img.loaded {
    opacity: 1;
  }

</style>
